module.exports = __webpack_public_path__ + "static/media/imgCanvasLean.fb845b81.svg";